export default "/wp-content/themes/custom-theme/dist/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?ec024da790d2972da002c9e3f0625ba5";